import React from 'react';
import { img_path } from '../../../environment';

// Extend props to include all standard <img> attributes (like style, onClick, etc.)
interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
}

const ImageWithBasePath: React.FC<ImageProps> = (props) => {
  const { src, alt, ...rest } = props;
  const fullSrc = `${img_path}${src}`;
  return <img src={fullSrc} alt={alt} {...rest} />;
};

export default ImageWithBasePath;
